import { getGroupValidations } from 'urbn-form-validations';

export function getGroupTypeForSelectedCountry(groupType) {
    return getGroupValidations(groupType);
}

export default {
    getGroupTypeForSelectedCountry
};

/**
 * Gets a country's group type values
 * @param  {Object} state       The current state of the redux store
 * @param  {String} countryCode Two-character country countryCode
 * @return {String}             The group type for the given country
 */
export function getGroupTypeByCountry(state, countryCode) {
    const matchingCountry = _.find(state.core.siteConfig.allCountries, (country) => country.countryCode === countryCode);
    // Ignore any fp prefixes to map fpgroup[i] -> group[i]
    return matchingCountry.groupType.replace(/^fp/, '');
}

/**
 * Replace newlines, script tags, and HTML with an empty string to avoid
 * unescaped characters and invalid name attribute assignents.
 * See https://goo.gl/LbnmmX
 * @param  {String}  val        The input value to sanitize
 * @return {String}
 */
export function sanitizeInput(val) {
    return val.replace(
        /(?:\r\n|\r|\n)|<script.*?>.*?<\/script>|<([^>]+?)([^>]*?)>([^<]*?)<\/\1>|<[^/>]*?\/>/gi,
        (match, p1, p2, p3) => p3 || ''
    );
}
